module.exports = __webpack_public_path__ + "static/media/icon_retiro_aporte_voluntario.6abb74d1.svg";